import React from 'react';
import PropTypes from 'prop-types';

import FeatureItem from './FeatureItem';
import Button from '../../elements/Button';
import './style.scss';

function Features(props) {
    const { title, description, button, featureItems, locale } = props;

    return (
        <div className="features-container">
            <div className="features-wrapper container">
                <div className="text-panel row g-0 justify-content-center">
                    <h2 className="col-12">{title}</h2>
                    <p className="segment-text col-lg-6">
                        {description[0].paragraph}
                    </p>
                    <div className="button-container col-12 row g-0 justify-content-center">
                        <Button src={button.link} value={button.text} />
                    </div>
                </div>
                <div className="features">
                    <div className="row">
                        {featureItems?.map((featureItem, i) => (
                            <FeatureItem
                                key={featureItem.title}
                                img={featureItem.image}
                                title={featureItem.title}
                                description={featureItem.description}
                                position={i}
                                link={featureItem.link}
                                locale={locale}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

Features.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.array.isRequired,
    featureItems: PropTypes.array.isRequired,
};

export default Features;
